export default "<!-- <full-calendar [options]=\"calendarOptions\"></full-calendar> -->\r\n<!-- [options]=\"calendarOptions\" -->\r\n";